export default "__VITE_ASSET__88cc6bf5__"